<template>
	<el-dialog custom-class="new-workorder" :title="!taskid ? '添加日程' : '编辑日程'" :visible.sync="dialogShow" width="600px" :close-on-click-modal="false" :modal-append-to-body="false">
		<el-form v-loading="loading" ref="taskForm" :model="taskForm" :rules="rules" label-position="left" label-width="120px">
			<el-form-item label="任务名称" prop="task_title">
				<el-input v-model="taskForm.task_title" placeholder="任务名称" />
			</el-form-item>
			<el-form-item label="开始时间" prop="starttime">
				<date-time-picker v-model="taskForm.starttime" />
			</el-form-item>
			<el-form-item label="任务描述" prop="remark">
				<el-input v-model="taskForm.remark" placeholder="任务描述" type="textarea" />
			</el-form-item>

		</el-form>
		<span slot="footer" class="flex-center">
			<el-button @click="dialogShow = false">取 消</el-button>
			<el-button type="primary" @click="submit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { postTaskApi, getTaskDetailApi } from '@/api/pm/taskApi'
export default {
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		taskid: {
			type: [Number, String],
			default: null
		},
	},

	components: {
		dateTimePicker: () => import('./dateTimePicker.vue')
	},
	data () {
		return {
			loading: false,
			taskForm: {
				starttime: null,
				remark: '',
				task_title: ''
			},
			taskDetail: {},
			rules: {
				task_title: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
				starttime: [
					{ required: true, message: '请选择开始时间', trigger: ['change', 'input', 'blur'] }
				],
			}
		}
	},
	computed: {
		dialogShow: {
			get () {
				return this.show
			},
			set (val) {
				this.$emit('update:show', val)
			}
		}
	},
	created () {
		this.taskid && this.fetchData()
	},
	methods: {
		fetchData () {
			this.loading = true
			getTaskDetailApi({ taskid: this.taskid }).then(res => {
				if (!res.errno) {
					this.taskDetail = res.data
					this.taskForm.task_title = res.data.task_title
					this.taskForm.remark = res.data.remark
					this.taskForm.starttime = res.data.starttime
				}
				this.loading = false
			})

		},
		submit () {
			this.$refs.taskForm.validate(vaild => {
				if (vaild) {
					let params = Object.assign({}, this.taskDetail, { taskid: this.taskid }, this.taskForm)
					postTaskApi(params).then(res => {
						if (!res.errno) {
							this.$message.success(this.taskid ? '修改成功！' : '新建成功！')
							this.$emit('update')
							this.dialogShow = false
						} else {
							this.$message.error(res.message)
						}
					})
				}
			})
		}
	}
}
</script>

<style>
</style>